module.exports = __webpack_public_path__ + "img/ctn_checkbox.edadb5ca.svg";